import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'

import colorContext from '../../../../Context/colorContext'
import { useStyles } from './styles'

interface ProfileCard {
  titulo: string
  url: string
}

const profileCards: ProfileCard[] = [
  { titulo: 'Cidadão', url: '/cidadao/servicos' },
  { titulo: 'Empresa', url: '/empresa/servicos' },
  { titulo: 'Servidor', url: '/servidor/servicos' },
  { titulo: 'Gestão Pública', url: '/gestao_publica/servicos' },
]

export default function ServiceByProfile(): JSX.Element {
  const { colors } = useContext(colorContext)
  const classes = useStyles({ colors })
  const history = useHistory()

  const handleNavigationToLink = (url: string): void => {
    history.push(url)
  }

  return (
    <Box className={classes.main}>
      <Box
        display="flex"
        maxWidth="1320px"
        width="100%"
        flexDirection="column"
        marginTop="10px"
      >
        <Box className={classes.box}>
          <Typography
            className={classes.textTitleInitial}
            variant="h5"
            component="h2"
          >
            Acesse Serviços Por Perfil
          </Typography>
        </Box>
        <Box className={classes.boxCards}>
          {profileCards.map((profile) => (
            <Card
              key={`${profile.titulo}-key`}
              className={classes.card}
              onClick={() => handleNavigationToLink(profile.url)}
            >
              <CardActionArea
                style={{
                  height: '100%',
                  color: colors.textAccentColor,
                }}
              >
                <CardContent
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    align="center"
                    variant="h5"
                    component="h3"
                    className={classes.cardTitle}
                  >
                    {profile.titulo}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
